module.exports = __webpack_public_path__ + "static/media/Background image.d9433837.jpg";